<template>
  <div class="results-content-block">
    <not-found v-if="hotels.length === 0 && !searching && !appending">
      <vb-button
        class="not-found__cta"
        v-if="filters_length > 0"
        :vb_options="{
          text: 'Rimuovi tutti i filtri e riprova',
          variant: 'outline-info',
          size: 'sm',
        }"
        @click="reset_filters"
      />
    </not-found>
    <dynamic-scroller
      page-mode
      ref="results-scroller"
      :items="items"
      :item-size="null"
      :min-item-size="100"
      key-field="id"
    >
      <template v-slot="{ item, index, active }">
        <dynamic-scroller-item
          class="pb-4"
          :item="item"
          :data-index="index"
          :active="active"
        >
          <component
            v-if="item.component"
            :is="item.component"
            v-bind="item.props"
          />
          <pad
            v-else
            :hotel="item"
            @toggle-map="toggle_map(item)"
            :nights="nights"
          />
        </dynamic-scroller-item>
      </template>
    </dynamic-scroller>
  </div>
</template>

<script>
import NotFound from "@/components/blocks/not-found";
import MarketingPad from "@/components/blocks/marketing-pad.vue";
import Pad from "@bookingv3/components/blocks/pad.vue";
import PadSeparator from "@bookingv3/components/blocks/pad-separator.vue";
import { add_extra_components_to_results } from "@/utilities";

export default {
  name: "results-content-block",

  components: {
    "not-found": NotFound,
    "marketing-pad": MarketingPad,
    "pad-separator": PadSeparator,
    pad: Pad,
  },

  props: {
    hotels: {
      type: Array,
      default: () => {
        return [];
      },
    },
    searching: Boolean,
    appending: Boolean,
    filters_length: Number,
    nights: Number,
    location: Object,
    location_separator_index: {
      type: Number,
      default: -1,
    },
  },
  computed: {
    items() {
      const items = [...this.hotels];
      if (this.location_separator_index >= 0) {
        items.splice(this.location_separator_index, 0, {
          id: `separator-${this.location_separator_index}`,
          component: "pad-separator",
          props: {
            search_count: this.location_separator_index,
          },
        });
      }
      return this.add_extra_components_to_results(items, "id");
    },
  },
  methods: {
    add_extra_components_to_results,
    reset_filters() {
      this.$emit("reset-filters");
    },
    toggle_map(payload) {
      this.$emit("toggle-map", payload);
    },
  },
};
</script>

<style lang="scss" scoped>
.results-content-block {
  &__not-found {
    border-radius: 10px;
    background-color: #fafcff;
    padding: 20px 30px;
    display: flex;
  }
}
@include media-breakpoint-down(md) {
  .not-found {
    margin: 2rem 0;
    text-align: center;
  }
}
</style>
